import Login from './component/Login'

export default Login